module.exports = __webpack_public_path__ + "img/research.0876b94c.png";